import type { ComponentType } from 'react';

import { surveyMode } from '@/v2/domains/Surveys/constants/constants';

import type { SurveyActionProps } from '../../types/surveyAction';
import ContinueAction from './ContinueAction';
import CtaAction from './CtaAction';

const actionByMode: Record<string, ComponentType<SurveyActionProps>> = {
  [surveyMode.CTA]: CtaAction,
  [surveyMode.SINGLE]: ContinueAction,
  [surveyMode.MULTIPLE]: ContinueAction,
};

export default function SurveyPrimaryAction(props: SurveyActionProps) {
  const Action = actionByMode[props.survey.mode] ?? ContinueAction;
  return <Action {...props} />;
}
